import { render, staticRenderFns } from "./ProuniFamilyMemberCard.vue?vue&type=template&id=444decfd&scoped=true&"
import script from "./ProuniFamilyMemberCard.vue?vue&type=script&lang=ts&"
export * from "./ProuniFamilyMemberCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniFamilyMemberCard.vue?vue&type=style&index=0&id=444decfd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444decfd",
  null
  
)

export default component.exports